// =============================================
// SERVICIO DE WHATSAPP
// =============================================

import api from './api';

const whatsappService = {
  // Obtener estado de conexión
  getStatus: async () => {
    const response = await api.get('/whatsapp/status');
    return response.data;
  },

  // Obtener QR code
  getQR: async () => {
    const response = await api.get('/whatsapp/qr');
    return response.data;
  },

  // Enviar recordatorios de deuda
  sendDebtReminders: async () => {
    const response = await api.post('/whatsapp/debt-reminder');
    return response.data;
  },

  // Enviar confirmación de pago
  sendPaymentConfirmation: async (paymentId) => {
    const response = await api.post(`/whatsapp/payment-confirmation/${paymentId}`);
    return response.data;
  },

  // Enviar notificación de nuevo período
  sendNewPeriodNotification: async (year, administratorName, ownerIds = []) => {
    const response = await api.post('/whatsapp/new-period', {
      year,
      administrator_name: administratorName,
      owner_ids: ownerIds
    });
    return response.data;
  },

  // Enviar mensaje personalizado
  sendCustomMessage: async (phone, message, ownerName = '') => {
    const response = await api.post('/whatsapp/send-message', {
      phone,
      message,
      owner_name: ownerName
    });
    return response.data;
  },
};

export default whatsappService;
